import {
  ModalBody,
  Text,
  UseDisclosureReturn,
  Button,
  Image,
  VStack,
} from '@chakra-ui/react'
import { Modal } from '../Modal/Modal'

import { translationsEN, translationsTH } from './constants'

type MaintenanceModalProps = {
  disclosure: UseDisclosureReturn
}

export const MaintenanceModal = (props: MaintenanceModalProps) => {
  const { disclosure } = props
  const { isOpen, onClose } = disclosure

  return (
    <Modal
      onClose={onClose}
      isOpen={process.env.NEXT_PUBLIC_IS_UNDER_MAINTENANCE === 'true' && isOpen}
      maxW="500px"
      isCentered
    >
      <ModalBody sx={{ pt: 10, textAlign: 'center' }}>
        <VStack>
          <Image
            src="/images/logo.svg"
            alt=""
            width="200px"
            height="200px"
          />
          <Text fontWeight="bold" fontSize="2xl" px={4}>
            {translationsEN.title}
          </Text>

          <Text fontWeight="medium" fontSize="lg" color="gray.600" px={4}>
            {translationsTH.title}
          </Text>

          <Text fontWeight="normal" fontSize="md" color="gray.700" px={4}>
            {translationsEN.message}
          </Text>

          <Text fontWeight="normal" fontSize="md" color="gray.500" px={4}>
            {translationsTH.message}
          </Text>
          <Text sx={{ color: 'brand.500' }}>nDataThoth Limited</Text>
        </VStack>
        <Button
          sx={{ alignSelf: 'stretch', mt: 6, width: 'full' }}
          size="lg"
          onClick={disclosure.onClose}
        >
          close
        </Button>
      </ModalBody>
    </Modal>
  )
}
